import "./Banners.scss";
import "react-status-alert/dist/status-alert.css";
import { useEffect, useState } from "react";
import { Alert } from "react-bootstrap";

import { getActiveBanners } from "../../Services/BannersService";
import { BannerResponse } from "../../interfaces/bannerInterfaces";

export const ActiveBanners = () => {
  const [banners, setBanners] = useState<BannerResponse[]>([]);

  const getAll = () => {
    getActiveBanners().then((response) => {
      if (response.data && response.data.data) {
        var datas = response.data.data;
        datas.forEach(data => {
          if (data.contenido.includes("img")) {
            var html = data.contenido;
            html = html.replaceAll(">", "width=\"100%\" > ");
            data.contenido = html;
          }
        });
        setBanners(datas);
      }
    });
  };

  const GetIcon = (severidad) => {
    let icon = "";
    if (severidad == "info") {
      icon = "info";
    } else if (severidad == "success") {
      icon = "check";
    } else if (severidad == "warning") {
      icon = "warning";
    } else if (severidad == "danger") {
      icon = "dangerous";
    }

    return <div className="material-icons">{icon}</div>;
  };

  useEffect(() => {
    getAll();
  }, []);

  return (
    <>
      {banners &&
        banners.map((banner, index) => (
          <Alert key={index} variant={banner.severidad} dismissible>
            {GetIcon(banner.severidad)}
            <div
              className="mb-12"
              dangerouslySetInnerHTML={{
                __html: banner.contenido,
              }}
            ></div>
          </Alert>
        ))}
    </>
  );
};
